import type { ButtonHTMLAttributes, CSSProperties } from "react";
import { BUTTON_RESET, PRESS_CLASS } from "./press";

export interface ShareBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "aria-label"> {
  /** The accessible name — always `t('…')`, never a literal. */
  label: string;
  onClick: () => void;
}

const BASE: CSSProperties = {
  ...BUTTON_RESET,
  color: "var(--d-fg-2)",
  display: "flex",
};

/**
 * The share affordance that sits in `Back`'s right slot: an 18×18 inline SVG
 * at stroke 1.5 in `currentColor`.
 *
 * Ported from `ShareBtn` in
 * `docs/design/handoff/design/templates/friends/friends-screen.jsx`.
 */
export function ShareBtn({
  label,
  onClick,
  className,
  style,
  ...rest
}: ShareBtnProps): JSX.Element {
  return (
    <button
      type="button"
      aria-label={label}
      className={className ? `${PRESS_CLASS} ${className}` : PRESS_CLASS}
      onClick={onClick}
      style={{ ...BASE, ...style }}
      {...rest}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M10 12.5V2.5M10 2.5 6.5 6M10 2.5 13.5 6M4 10v6.5h12V10" />
      </svg>
    </button>
  );
}

export default ShareBtn;
